import * as React from "react";
import styled from "../../../styled/index";
import { BaseInputCSS } from "../input/index";
const SelectComponent = styled("select") `
  ${BaseInputCSS};
  option {
    padding: 5px 0;
    &:disabled {
      background-color: darken(white, 15%);
    }
  }
`;
export const Select = (props) => (React.createElement(SelectComponent, Object.assign({}, props),
    props.placeholder && React.createElement("option", { value: "" }, props.placeholder || ""),
    props.options.map((o, i) => {
        return (React.createElement("option", { key: i, value: o.value, disabled: o.disabled || false }, o.label));
    })));
//# sourceMappingURL=index.js.map